import http from 'apis/config/http-service';
import { useCallback } from 'react';

const endpoint = 'ums/v1/cms/invoice-scanning/scans';

type TOption = {
  value: number;
  label: string;
};

interface InvoiceScanDto {
  id: number;
  invoiceNumber: string | null;
  vendorName: string | null;
  totalAmount: number | null;
  currency: string | null;
  invoiceDate: string | null;
  status: string;
}

export function useSearchInvoiceScansApi() {
  const loadOptions = useCallback(
    (restaurantId: number) => (_inputValue: string, callback: (options: TOption[]) => void) => {
      if (!restaurantId) {
        callback([]);
        return;
      }

      http
        .get(endpoint, {
          params: {
            restaurantId,
            page: 1,
            limit: 20,
          },
        })
        .then((res) => {
          const options: TOption[] = (res?.data?.data || []).map((item: InvoiceScanDto) => ({
            value: item.id,
            label: `#${item.id}${item.invoiceNumber ? ` — ${item.invoiceNumber}` : ''}${item.vendorName ? ` — ${item.vendorName}` : ''}${item.totalAmount != null ? ` — ${item.totalAmount} ${item.currency || 'AED'}` : ''}`,
          }));
          callback(options);
        })
        .catch(() => callback([]));
    },
    []
  );

  return { loadOptions };
}
